const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/cm/internal/email/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { LanguageModel } from '@/api/generated/models/languageModel';
import type { RecipientTypeModel } from '@/api/generated/models/recipientTypeModel';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/cm/internal/email/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}